import { Countries } from '@merchant-portal/mp-models';
class CurrencySymbol {
    constructor(suffix = '') {
        this.suffix = suffix;
    }
    wrap(value) {
        return [value, this.suffix].filter((v) => !!v).join(' ');
    }
    toString() {
        return this.suffix;
    }
}
export const getCurrencySymbol = (countryCode) => {
    switch (countryCode) {
        case Countries.FI:
            return new CurrencySymbol('€');
        case Countries.DK:
            return new CurrencySymbol('kr.');
        case Countries.SE:
        case Countries.NO:
        default:
            return new CurrencySymbol('kr');
    }
};
